<template lang="pug">
  b-container(fluid)
    b-row
      b-col.page-wrap(cols="12")
        // 하위사용자 추가, 사용자 일괄 등록 등 조작 헤더
        div.page-header(slot="header")
          b-container.d-flex.justify-content-between(fluid, v-if="!AppState.isStandalone")
            div.mb-1
              span.page-title {{$t('user')}} {{$t('manage')}}
          b-row.d-flex.justify-content-between(style="width: 100%;")
            // 검색창
            b-col(cols="4" style="padding-left: 0")
              //b-input-group.w-100(size="sm")
              b-input-group.w-100(size="sm")
                template(slot="prepend")
                  b-dropdown(:text="$t(search.key.text)", size="sm", variant="grey-200")
                    b-dropdown-item(
                      v-for="opt in search.options",
                      :key="opt.value",
                      @click="setSearchKey(opt)") {{$t(opt.text)}}
                b-form-input(v-if="search.key.value !== 'active'", v-model="search.value", @keypress.enter="searchHandler")
                b-form-select(
                  v-model="activeSelected",
                  v-if="search.key.value === 'active'",
                  :options="dropdownActive"
                  @change="setActiveRefresh"
                  )
                b-input-group-append.ml-2
                  b-btn(@click="searchHandler") {{$t('search')}}
            div.ml-auto
              b-btn(size="sm", @click="handleAddManager") {{$t('add_user')}}
              b-btn.ml-2(v-if="!AppState.env.VUE_APP_SCI" size="sm", :to="{name: 'excel-add-manager-component'}") {{$t('excel-users')}}
              b-btn.ml-2.delete-btn(variant="danger" size="sm", @click="checkedRemoteUser") {{$t('delete')}}

        // table 관련 view
        b-card.table-card
          b-table(
            ref="userTable",
            :fields="fields",
            :items="managers",
            :current-page="page.current",
            :per-page="page.per",
            :empty-text="$t('no-content')",
            tbody-class="lmm-table-body",
            sort-by="mgrid",
            :sort-desc="false",
            show-empty
            )
            template(slot="HEAD_member_type_id", slot-scope="data")
            template(v-slot:head(check)="row")
              b-form-checkbox(v-model="allSelected" @input="selectAllRows")
            template(slot="HEAD_mgrid", slot-scope="data") {{$t('user')}}
            template(slot="HEAD_name", slot-scope="data") {{$t('name')}}
            template(slot="HEAD_department", slot-scope="data") {{$t('department')}}
            template(slot="HEAD_position", slot-scope="data") {{$t('cowork_position')}}
            template(slot="HEAD_phone", slot-scope="data") {{$t('phone')}}
            template(slot="HEAD_flag_active", slot-scope="data") {{$t('status')}}
            template(slot="HEAD_remove", slot-scope="data") {{$t('delete')}}

            template(v-slot:cell(member_type_id)="row")
              icon(v-if="AppState.perm.isApprover && row.item.member_type_id === 6 || row.item.member_type_id === 2" name="user-cog", scale="1.5")
              icon(v-else-if="row.item.member_type_id === 7" name="handshake", scale="1.5")
            // 사용자명 관련 링크 코드
            template(v-slot:cell(check)="row")
              b-form-checkbox(v-model="row.item.isSelected" @change="handleCheck(row.item)")
            template(v-slot:cell(mgrid)="row")
              b-btn(variant="link", :to="{name: 'edit-manager', params: {userPk: row.item.pk}}") {{row.item.mgrid}}
            template(v-slot:cell(flag_active)="row")
              switches.lmm-switch(
                v-model="row.item.flag_active",
                theme="bootstrap",
                :color="row.item.flag_active ? 'warning' : 'default'",
                @input="activeChanged(row.item.pk, row.item.flag_active, row.item)")
            template(v-slot:cell(remove)="row")
              b-button(size="sm", variant="danger", @click="remoteUser(row.item)")
                icon(name="trash")
          // 하단 페이지 관련 설정
          div.d-flex.justify-content-between(slot="footer")
            div
              b-form-select(
                size="sm",
                v-model="page.per",
                :options="page.perOptions")
            b-pagination(
              size="sm",
              :total-rows="page.total",
              :per-page="page.per",
              v-model="page.current",
              class="my-0 float-right"
            )
</template>

<script>
import Switches from 'vue-switches'
import {UsersAPI} from '../../api'
import _ from "lodash";
import store from 'store'

export default {
  name: 'manager-list-component',
  components: { Switches },
  methods: {
    searchHandler () {
      this.$refs.userTable.refresh()
    },
    managers (ctx) {
      this.pageMounted = false
      let params = {
        by: ctx.sortBy,
        flag_servant: true,
        limit: ctx.perPage,
        offset: (ctx.currentPage - 1) * ctx.perPage,
        order: ctx.sortDesc ? 'desc' : 'asc',
        search_mode: 'pagination'
      }
      this.checkedUser = []
      if (params.by === '') return

      if (this.search.value) {
        params.search_key = this.search.key.value
        params.search_value = this.search.value
      }

      if (this.activeSelected === 'active') {
        params.sort_active = 'active'
      } else if (this.activeSelected === 'inactive') {
        params.sort_active = 'inactive'
      }

      if (params.by === 'mail') {
        params.by = 'email'
      }

      return UsersAPI.get('', {params})
        .then(resp => {
          this.sortUsersByResponse(resp.data.objects)
          setTimeout(() => {
            this.pageMounted = true
          }, 300)
          this.page.total = resp.data.meta.total_count
          this.allSelected = false
          this.showTableUser = resp.data.objects

          return resp.data.objects
        })
    },
    activeChanged (key, value, user) {
      if (!this.pageMounted) return
      key += ''
      let params = { flag_active: value }
      UsersAPI.put(key, params)
      let readable = value ? this.$t('active') : this.$t('inactive')
      this.$awn.success(this.$t('user_active_changed', {name: user.name, status: readable}))
    },
    remoteUser (user) {
      let params = {
        title: 'LinkMeMine',
        context: {path: 'delete_user_confirm'},
        withoutInput: true,
        submit: {
          size: 'sm',
          color: 'danger',
          text: {path: 'delete'}
        }
      }
      this.AppState.$emit('show-confirm-dialog', params, (key, data) => {
        if (key !== 'submit') return
        UsersAPI.delete(`${user.pk}`)
          .then(resp => {
            this.$awn.success(this.$t('deleted_user'))
            this.$refs.userTable.refresh()
          })
      })
    },
    checkedRemoteUser () {
      if (this.checkedUser.length === 0) {
        return this.$awn.warning(this.$t('select_delete_user'))
      }
      let params = {
        title: 'LinkMeMine',
        context: {path: 'delete_checked_user_confirm'},
        withoutInput: true,
        submit: {
          size: 'sm',
          color: 'danger',
          text: {path: 'delete'}
        },
      }
      const usersPK = this.checkedUser.map(e => e.pk)
      this.AppState.$emit('show-confirm-dialog', params, (key, data) => {
        if (key !== 'submit') return
        for (const user of usersPK) {
          UsersAPI.delete(user.toString())
              .then(resp => {
                this.$awn.success(this.$t('deleted_user'))
                this.$refs.userTable.refresh()
              })
        }

      })
    },
    setSearchKey (opt) {
      this.search.value = null
      this.search.key = opt
      this.activeSelected = opt.value
      // sort를 활성화로 바꿀 때 테이블을 새로고침
      if (this.search.key.text === 'active') {
        this.sortActiveFlag = true
        this.$refs.userTable.refresh()
      }
      // sort가 활성화인 상태에서 다른 것으로 변경할 때만 테이블을 새로고침
      if (this.search.key.text !== 'active' && this.sortActiveFlag) {
        this.sortActiveFlag = false
        this.$refs.userTable.refresh()
      }
    },
    setActiveRefresh () {
      this.$refs.userTable.refresh()
    },
    handleCheck(item) {
      if (this.checkedUser.includes(item)) {
        const index = this.checkedUser.findIndex(u => u.pk === item.pk);
        this.checkedUser.splice(index, 1);
      }
      if (item.isSelected) {
        this.checkedUser.push(item);
      }
    },
    selectAllRows() {
      _.each(this.showTableUser, v => {
        v.isSelected = this.allSelected;
        this.handleCheck(v)
      })
    },
    sortUsersByResponse(data) {
      data.sort((a, b) => {
        if (a.flag_active && !b.flag_active) return -1;
        if (!a.flag_active && b.flag_active) return 1;

        if (a.member_type_id === 6 && b.member_type_id !== 6) return -1;
        if (a.member_type_id !== 6 && b.member_type_id === 6) return 1;

        if (a.member_type_id !== 7 && b.member_type_id === 7) return -1;
        if (a.member_type_id === 7 && b.member_type_id !== 7) return 1;

        return 0; // 나머지 경우에는 순서 변경 없음
      })
    },
    handleAddManager() {
      let managerLimit = store.get('user').license.total.managerLimit
      if (this.showTableUser.length < managerLimit) {
        this.$router.push({ name: 'add-manager' })
      } else {
        this.$awn.warning(this.$t('sub_manager_limit'))
      }
    },
  },
  data () {
    return {
      pageMounted: false,
      sortActiveFlag: false,
      checkedUser: [],
      allSelected: false,
      showTableUser: [],
      fields: [
        { key: 'member_type_id', label: '', sortable: false },
        {
          key: 'check',
          label: '',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false
        },
        { key: 'mgrid', label: this.$t('ID'), sortable: true },
        { key: 'name', label: this.$t('name'), sortable: true },
        { key: 'department', label: this.$t('department'), sortable: false },
        { key: 'mail', label: this.$t('Email'), sortable: true },
        { key: 'phone', label: this.$t('phone'), sortable: true },
        { key: 'flag_active', label: this.$t('active'), sortable: false },
        // { key: 'remove', label: this.$t('delete'), sortable: false }
      ],
      page: {
        total: 0,
        current: 1,
        per: 10,
        perOptions: [
          { value: 5, text: '5' },
          { value: 10, text: '10' },
          { value: 15, text: '15' },
          { value: 20, text: '20' }
        ]
      },
      search: {
        key: { value: 'mgrid', text: 'ID' },
        options: [
          { value: 'mgrid', text: 'ID' },
          { value: 'name', text: 'name' },
          { value: 'department', text: 'department' },
          { value: 'Email', text: 'Email' },
          { value: 'phone', text: 'phone' },
          { value: 'active', text: 'active' },
        ],
        value: null
      },
      activeSelected: null,
      dropdownActive: [
        {value: 'active', text: this.$t('active')},
        {value: 'inactive', text: this.$t('inactive')}
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
.row, .col, .container-fluid {
  margin: 0;
  padding: 0;
}

.page-wrap {
  padding: 1rem 1.5rem;
}

.page-header {
  padding: 0 1.5rem 0 1.5rem;
  margin-bottom: 0.5rem;
}

.card {
  border-radius: 0;
  .card-body {
    padding: 0;
  }
  //.card-footer {
  //  border-top: none;
  //  padding: 0.3rem 1.25rem;
  //}
}


.btn-secondary {
  color: black !important;
  font-weight: 400;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #F7F7F7 !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #CBCBCB !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.delete-btn {
  background-color: $mainTheme !important;
  color: #FFFFFF !important;
  border: 1px solid $mainTheme !important;
  font-weight: 400;
  &:hover {
    background-color: $hover !important;
    color: #FFFFFF !important;
    border: 1px solid $hover !important;
    font-weight: 400;
  }
}

::v-deep .b-table {
  margin: 0;
  tr, th {
    padding: 0.5rem 0 0.5rem 1rem;
    position: relative;
    font-weight: 400;
  }
  td {
    padding: 0 0 0 1rem;
    color: #6F6F6F;
    font-weight: 400;
  }
  th:nth-child(1), th:nth-child(2) {
    width: 1%;
  }
  th:nth-child(3), th:nth-child(4), th:nth-child(5), th:nth-child(6), th:nth-child(7) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
    width: 13%;
  }
  td:nth-child(3), td:nth-child(4), td:nth-child(5), td:nth-child(6), td:nth-child(7) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
  }
}

.btn-link {
  padding: 0.41rem 0.75rem 0.41rem 0;
  font-size: 14px;
}

svg {
  color: #ababab;
}

</style>
